import React, { useState, useEffect } from "react";
import { Card, Select, Button, Space, message, Spin } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";
import sellersListQuery from "../queries/sellersListQuery";
import updateOrgMutation from "../queries/updateOrgMutation";

const { Option } = Select;

const MarketplaceOrgSettings = ({ org, onUpdate }) => {
  const [sellers, setSellers] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(true);

  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const fetchSellers = async () => {
    try {
      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const response = await axios.post(
        graphqlUrl,
        {
          query: sellersListQuery,
          variables: { first: 1000 },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const edges = response.data?.marketplace_sellers?.edges || [];
      setSellers(edges.map((edge) => edge.node));
    } catch (error) {
      console.error("Error fetching sellers:", error);
      setSellers([]);
    } finally {
      setLoading(false);
    }
  };

  const updateSellerLink = async () => {
    setUpdating(true);
    try {
      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const fields = {
        marketplace_seller_pointer: selectedSeller ? { link: selectedSeller } : null,
      };

      await axios.post(
        graphqlUrl,
        {
          query: updateOrgMutation,
          variables: { id: org.objectId, fields },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success("Profilo venditore aggiornato con successo");
      if (onUpdate) onUpdate(); // Trigger refresh in parent
    } catch (error) {
      console.error("Error updating seller:", error);
      message.error("Errore durante l'aggiornamento del profilo venditore");
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    fetchSellers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (org) {
      setSelectedSeller(org.marketplace_seller_pointer?.objectId || null);
    }
  }, [org]);

  if (loading) {
    return (
      <Card title="Impostazioni">
        <Spin />
      </Card>
    );
  }

  return (
    <Card title="Impostazioni">
      <div style={{ maxWidth: 600 }}>
        <h3>Profilo Venditore Collegato</h3>
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <Select
            style={{ width: "100%" }}
            placeholder="Seleziona un profilo venditore"
            value={selectedSeller}
            onChange={setSelectedSeller}
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {sellers.map((seller) => (
              <Option key={seller.objectId} value={seller.objectId}>
                {seller.name} {!seller.enabled && "(Disattivo)"}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            onClick={updateSellerLink}
            loading={updating}
            disabled={selectedSeller === org.marketplace_seller_pointer?.objectId}
          >
            Salva Profilo Venditore
          </Button>
          {org.marketplace_seller_pointer && (
            <Link to={`/funeralcloud/sellers/${org.marketplace_seller_pointer.objectId}`}>
              Visualizza profilo venditore corrente →
            </Link>
          )}
        </Space>
      </div>
    </Card>
  );
};

export default MarketplaceOrgSettings;
